// /lib/revalidateDefaults.js
export function getRevalidatDefault_GET(method = 'GET', revalidateInSeconds = 3) {
    return {
        method,
        headers: {
            'Content-Type': 'application/json',
            'X-API-Key': process.env.X_API_Key, // 只帶環境變數
        },
        cache: 'force-cache',
        next: { revalidate: revalidateInSeconds },
    }
}
export function getRevalidatDefault_GET_NoCache(method = 'GET') {
    return {
        method,
        headers: {
            'Content-Type': 'application/json',
            'X-API-Key': process.env.X_API_Key, // 只帶環境變數
        },
        cache: 'no-store',
    }
}


export function getRevalidatDefault_POST(method = 'POST', revalidateInSeconds = 3) {
    return {
        method,
        headers: {
            'Content-Type': 'application/json',
            'X-API-Key': process.env.X_API_Key, // 只帶環境變數
        },
        cache: 'force-cache', //強制保存快取 
        next: { revalidate: revalidateInSeconds },
    }
}

export function getRevalidatDefault_POST_NoCache(method = 'POST') {
    return {
        method,
        headers: {
            'Content-Type': 'application/json',
            'X-API-Key': process.env.X_API_Key, // 只帶環境變數
        },
        cache: 'no-store',
    }
}